export default __webpack_public_path__ + "static/media/SBGO.0af01503.png";